module.exports = __webpack_public_path__ + "media/images/cluster-2-digit-e5f3112064ca91088b4407361d3f2f56.png";